import React from 'react';
import { Input } from '@ui';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  value: string;
  name?: string;
  hint?: string;
  checked?: boolean;
  className?: string;
}

const Radio: React.FC<RadioProps> = ({ id, value, name, checked, className = '', ...props }) => {
  return (
    <>
      <label className={['radio', className].filter(Boolean).join(' ')} htmlFor={id}>
        <Input id={id} type='radio' name={name} value={value} checked={checked} {...props} />
        {value}
      </label>
    </>
  );
};

export default Radio;
